/** 토큰 디버그 로그. 전체 JWT 는 출력하지 않는다. */
export function tokenDebugInfo(token?: string | null) {
  if (!token || token === "null" || token === "undefined") {
    return { hasToken: false, tokenPrefix: null, tokenLength: 0 };
  }
  return {
    hasToken: true,
    tokenPrefix: token.slice(0, 12),
    tokenLength: token.length
  };
}

export function logKeycloakToken(
  step: string,
  details?: Record<string, unknown>
): void {
  if (typeof window === "undefined" || window.location.hostname !== "localhost")
    return;
  // eslint-disable-next-line no-console
  console.log(`[keycloak:token] ${step}`, details ?? {});
}
